var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailaddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.57 19.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#dde4e7;}.cls-5{fill:#a2bac6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 19.57,
    height: 19.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,9.06v1.49A9.8,9.8,0,1,0,0,9.06"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5.03,
    y: -4.99,
    width: 29.59,
    height: 29.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.92,12.68V6.83s0,0,0,0l0-.08a.71.71,0,0,0-.7-.6H5.09a.72.72,0,0,0-.7.6l0,.08v5.94s0,0,0,.08a.72.72,0,0,0,.7.6h9.1a.71.71,0,0,0,.7-.6s0-.06,0-.08,0,0,0-.05M5.17,7.62,8.08,9.76,5.17,11.9Zm5.15,1.79h0l-.68.5L9,9.42H9L5.54,6.91h8.2Zm-1.56.84.64.48a.4.4,0,0,0,.48,0l.65-.48,3.21,2.36H5.54Zm2.44-.49,2.92-2.14V11.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailaddressIcon);
export default __webpack_public_path__ + "static/media/emailaddress-icon.fe800eddfcbb8a3fbc21062cdf4eeb14.svg";
export { ForwardRef as ReactComponent };